import React from 'react';
import { DARK_THEME } from '../../lib/theme.js';

export function PrivacyPolicyPage() {
  const theme = DARK_THEME;

  return (
    <div style={{
      minHeight: '100vh',
      background: theme.bg,
      color: theme.text,
      fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif',
    }}>
      <SimpleHeader theme={theme} />

      <article style={{
        maxWidth: 760,
        margin: '0 auto',
        padding: '40px 20px 80px',
        lineHeight: 1.65,
        fontSize: 15,
      }}>
        <h1 style={{ fontSize: 32, fontWeight: 800, letterSpacing: -1, margin: 0 }}>Privatlivspolitik</h1>
        <p style={{ color: theme.textMuted, fontSize: 13, margin: '8px 0 32px' }}>
          Sidst opdateret: 8. maj 2026
        </p>

        <Section title="1. Indledning">
          <p>
            Velkommen til Tag Team. Denne privatlivspolitik beskriver hvordan vi indsamler, bruger og beskytter
            dine personlige oplysninger når du bruger Tag Team-appen og hjemmesiden gettagteam.com.
          </p>
          <p>
            Tag Team udvikles og drives af <strong>Anka Media</strong>, der er dataansvarlig for behandlingen
            af dine personoplysninger.
          </p>
          <p><strong>Kontaktoplysninger på dataansvarlig:</strong></p>
          <p>
            Anka Media<br />
            Varde, Danmark<br />
            E-mail: hej@gettagteam.com
          </p>
        </Section>

        <Section title="2. Hvilke oplysninger indsamler vi?">
          <h3 style={subheadingStyle(theme)}>2.1 Oplysninger du selv giver os</h3>
          <p>Når du opretter en konto eller bruger appen, indsamler vi:</p>
          <ul>
            <li><strong>Kontoinformation:</strong> Dit navn, e-mailadresse og profilbillede</li>
            <li><strong>Login-information:</strong> Hvis du logger ind via Google eller Facebook, modtager vi dit navn, din e-mail og dit profilbillede fra disse tjenester</li>
            <li><strong>Indhold du opretter:</strong> De opgaver du opretter, beskeder du sender til din partner, belønninger du sætter, og varer på indkøbslisten</li>
            <li><strong>Profilindstillinger:</strong> Notifikationspræferencer, tema (lys/mørk), og lignende valg</li>
          </ul>

          <h3 style={subheadingStyle(theme)}>2.2 Oplysninger vi automatisk indsamler</h3>
          <p>Når du bruger Tag Team, indsamler vi automatisk:</p>
          <ul>
            <li><strong>Anvendelsesdata:</strong> Hvilke funktioner du bruger, hvor ofte du åbner appen, og hvilke handlinger du udfører</li>
            <li><strong>Tekniske oplysninger:</strong> Enhedstype, operativsystem, app-version, og IP-adresse</li>
            <li><strong>Crash-data:</strong> Hvis appen crasher, indsamler vi tekniske detaljer om fejlen</li>
          </ul>

          <h3 style={subheadingStyle(theme)}>2.3 Oplysninger om din partner</h3>
          <p>
            Tag Team er bygget til at blive brugt af to personer. Når du forbinder med en partner, kan din partner se:
          </p>
          <ul>
            <li>Dit navn og profilbillede</li>
            <li>Opgaver du sender til vedkommende</li>
            <li>Beskeder og belønninger du tilknytter opgaver</li>
            <li>Varer du tilføjer til den fælles indkøbsliste</li>
            <li>Statistikker over din aktivitet i jeres fælles "pair" (kærlighedspoint, streaks)</li>
          </ul>
          <p>Din partner kan <strong>ikke</strong> se:</p>
          <ul>
            <li>Dine private opgaver (medmindre du markerer dem som fælles eller sender dem)</li>
            <li>Dine personlige notifikationsindstillinger</li>
            <li>Din e-mailadresse (medmindre du selv deler den)</li>
          </ul>
        </Section>

        <Section title="3. Reklamer og tracking">
          <p>
            Tag Team finansieres delvist gennem reklamer i den gratis version af appen.
          </p>
          <h3 style={subheadingStyle(theme)}>3.1 Reklamer i den gratis version</h3>
          <p>
            I den gratis version af Tag Team kan der vises reklamer fra tredjepartsudbydere, primært
            <strong> Google AdMob</strong> og/eller lignende reklamenetværk. Disse reklamer kan være
            tilpasset baseret på generelle interesse-kategorier, men aldrig på det konkrete indhold du
            opretter i appen.
          </p>
          <h3 style={subheadingStyle(theme)}>3.2 Hvilke data deles med reklamenetværk?</h3>
          <ul>
            <li><strong>Enhedsidentifikator</strong> (Apple Advertising ID på iPhone, Google Advertising ID på Android)</li>
            <li><strong>Tilnærmet geografisk placering</strong> baseret på IP-adresse</li>
            <li><strong>Tekniske oplysninger</strong> om din enhed</li>
            <li><strong>Generelle interesse-kategorier</strong> — aldrig dine konkrete opgaver eller beskeder</li>
          </ul>
          <h3 style={subheadingStyle(theme)}>3.3 Dine rettigheder vedr. reklamer</h3>
          <p>Du kan altid:</p>
          <ul>
            <li>Fravælge personaliserede reklamer i appens indstillinger og i din enheds privatlivsindstillinger</li>
            <li>Slå reklamer helt fra med Tag Team Premium-abonnementet</li>
            <li>Trække samtykke tilbage til behandling af data til reklameformål</li>
          </ul>
          <h3 style={subheadingStyle(theme)}>3.4 Indhold er aldrig genstand for reklamemålretning</h3>
          <p>
            Vi bruger <strong>aldrig</strong> indholdet af dine opgaver, beskeder, belønninger eller
            indkøbsliste til at målrette reklamer.
          </p>
        </Section>

        <Section title="4. Hvad bruger vi oplysningerne til?">
          <p>Vi bruger dine personoplysninger til følgende formål:</p>
          <ul>
            <li>At levere selve appen og dens funktioner</li>
            <li>At sende notifikationer du har valgt at modtage</li>
            <li>At forbedre appen baseret på anonymiseret brugsdata</li>
            <li>At vise reklamer i den gratis version</li>
            <li>At forhindre misbrug og sikre app-sikkerheden</li>
          </ul>
          <p>
            <strong>Vi sælger aldrig dit indhold til tredjeparter.</strong><br />
            <strong>Vi viser ingen reklamer i Premium-versionen.</strong>
          </p>
        </Section>

        <Section title="5. Hvem deler vi oplysninger med?">
          <p>Vi deler dine oplysninger med følgende kategorier af modtagere som databehandlere:</p>
          <ul>
            <li><strong>Supabase</strong> (databasen og brugerautentificering)</li>
            <li><strong>Vercel</strong> (hosting af hjemmesiden og API'et)</li>
            <li><strong>Resend</strong> (sender transaktionelle e-mails)</li>
            <li><strong>Google og Facebook</strong> (kun hvis du logger ind via disse tjenester)</li>
          </ul>
        </Section>

        <Section title="6. Hvor opbevares dine data?">
          <p>
            Dine data opbevares primært i <strong>EU</strong> (specifikt i Frankfurt-regionen via
            Supabase EU-instanser). Hvis data overføres uden for EU, sker det under passende juridiske
            rammer (EU-Kommissionens standardkontraktbestemmelser).
          </p>
        </Section>

        <Section title="7. Hvor længe gemmer vi dine data?">
          <ul>
            <li>Aktive konto-oplysninger: så længe din konto er aktiv</li>
            <li>Inaktiv konto: slettes efter 24 måneders inaktivitet</li>
            <li>Slettet konto: permanent fjernet inden for 30 dage</li>
            <li>Crash-logs: 90 dage</li>
            <li>Faktura- og regnskabsdata (ved Premium-køb): 5 år (lovpligtig opbevaring)</li>
          </ul>
        </Section>

        <Section title="8. Dine rettigheder">
          <p>Som registreret har du følgende rettigheder under GDPR:</p>
          <ul>
            <li><strong>Indsigt</strong> i hvilke personoplysninger vi har om dig</li>
            <li><strong>Berigtigelse</strong> — få ukorrekte oplysninger rettet</li>
            <li><strong>Sletning</strong> — "retten til at blive glemt"</li>
            <li><strong>Begrænsning</strong> af behandlingen</li>
            <li><strong>Dataportabilitet</strong> — modtage dine data i et maskinlæsbart format</li>
            <li><strong>Indsigelse</strong> mod vores behandling — herunder til reklameformål</li>
            <li><strong>Tilbagekaldelse af samtykke</strong> til enhver tid</li>
          </ul>
          <p>
            For at udøve disse rettigheder, kontakt os på <strong>hej@gettagteam.com</strong>.
            Vi besvarer alle henvendelser inden for 30 dage.
          </p>
          <p>
            Du har også ret til at klage til <strong>Datatilsynet</strong> (
            <a href="https://www.datatilsynet.dk" style={linkStyle(theme)} target="_blank" rel="noopener noreferrer">
              www.datatilsynet.dk
            </a>).
          </p>
        </Section>

        <Section title="9. Sikkerhed">
          <ul>
            <li><strong>Kryptering</strong> af data i transit (HTTPS/TLS) og hvile (database-niveau)</li>
            <li><strong>Adgangskontrol</strong> — kun autoriseret personale har adgang</li>
            <li><strong>Row Level Security</strong> — database-niveau-isolation</li>
            <li><strong>Backup</strong> — daglig backup, opbevaret i mindst 30 dage</li>
          </ul>
          <p>
            Hvis der skulle opstå et datalæk, vil vi underrette Datatilsynet inden for 72 timer
            og berørte brugere uden ugrundet ophold ved høj risiko.
          </p>
        </Section>

        <Section title="10. Børn">
          <p>
            Tag Team er ikke beregnet til børn under 16 år. Vi indsamler ikke bevidst personoplysninger
            fra børn under 16.
          </p>
        </Section>

        <Section title="11. Ændringer i denne politik">
          <p>
            Vi kan opdatere denne privatlivspolitik fra tid til anden. Ved væsentlige ændringer vil vi
            underrette dig via e-mail og vise en meddelelse i appen.
          </p>
        </Section>

        <Section title="12. Kontakt">
          <p>Har du spørgsmål til vores behandling af dine personoplysninger?</p>
          <p>
            📧 <strong>hej@gettagteam.com</strong><br />
            📍 <strong>Anka Media, Varde, Danmark</strong>
          </p>
        </Section>

        <p style={{ marginTop: 48, fontSize: 12, color: theme.textDim, fontStyle: 'italic', textAlign: 'center' }}>
          Denne privatlivspolitik er udarbejdet i overensstemmelse med Databeskyttelsesforordningen (GDPR)
          og Databeskyttelsesloven.
        </p>
      </article>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section style={{ marginBottom: 32 }}>
      <h2 style={{ fontSize: 21, fontWeight: 700, letterSpacing: -0.4, margin: '0 0 12px' }}>{title}</h2>
      {children}
    </section>
  );
}

function subheadingStyle(theme) {
  return {
    fontSize: 16,
    fontWeight: 600,
    margin: '20px 0 8px',
    color: theme.text,
  };
}

function linkStyle(theme) {
  return {
    color: theme.coral,
    textDecoration: 'underline',
  };
}

function SimpleHeader({ theme }) {
  return (
    <header style={{
      padding: '14px 20px',
      borderBottom: `1px solid ${theme.border}`,
    }}>
      <div style={{
        maxWidth: 760,
        margin: '0 auto',
      }}>
        <a href="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, textDecoration: 'none', color: theme.text }}>
          <svg width="28" height="28" viewBox="0 0 120 120">
            <g transform="translate(60,60)">
              <rect x="-30" y="-20" width="20" height="40" rx="3" fill={theme.coral}/>
              <rect x="-36" y="-20" width="32" height="9" rx="3" fill={theme.coral}/>
              <rect x="6" y="-22" width="20" height="40" rx="3" fill={theme.gold}/>
              <rect x="0" y="-22" width="32" height="9" rx="3" fill={theme.gold}/>
            </g>
          </svg>
          <span style={{ fontSize: 16, fontWeight: 700 }}>Tag Team</span>
        </a>
      </div>
    </header>
  );
}
